module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    attrs: {
      "id": "pageHeader"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('h1', [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), (_vm.content) ? _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.content)
    }
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "src": _vm.headerImage,
      "width": "800",
      "height": "290"
    }
  })])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-5e22c45a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/layouts/PageHeader.vue
// module id = 390
// module chunks = 2